import { render, staticRenderFns } from "./MiniProgramRuiShiLiGouWuWxUsers.vue?vue&type=template&id=887a9f10&scoped=true&"
import script from "./MiniProgramRuiShiLiGouWuWxUsers.vue?vue&type=script&lang=js&"
export * from "./MiniProgramRuiShiLiGouWuWxUsers.vue?vue&type=script&lang=js&"
import style0 from "./MiniProgramRuiShiLiGouWuWxUsers.vue?vue&type=style&index=0&id=887a9f10&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "887a9f10",
  null
  
)

export default component.exports